<template>
  <div>
    <top-header-info></top-header-info>
    <top-logo state="1"></top-logo>
    <right-nav></right-nav>
    <home-nav></home-nav>
    <div>
      <div class="w">
        <div class="site-nav">
          <router-link :to="{ name: 'index' }">首页</router-link>>
          <router-link :to="{ name: 'user-center' }">个人中心</router-link>>
          订单详情
        </div>
        <left-userinfo state="1"></left-userinfo>
        <div class="right-detail-wrap">
          <div class="top-info">
            <el-row :gutter="20">
              <el-col :span="10"
                >订单编号：{{ orderInfo.id }}
                <span
                  class="copy-btn"
                  @click="copyOrderId"
                  :data-clipboard-text="orderInfo.id"
                  >复制</span
                >
              </el-col>
              <el-col :span="10">收货人：{{ orderInfo.shipping_name }}</el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="10">
                订单状态：
                <span class="big_word">{{ orderInfo.status }}</span>
                <pay-countdown
                  v-if="endTime && orderInfo.status_id === 1"
                  class="count"
                  :endTime="endTime"
                ></pay-countdown>
                <span
                  v-if="endTime && orderInfo.status_id === 1"
                  class="red-color"
                  >后取消订单</span
                >
              </el-col>
              <el-col :span="10">手机号码：{{ phone_format }}</el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="10">下单时间：{{ orderInfo.created_at }}</el-col>
              <el-col :span="10">
                地址：{{ orderInfo.zone && orderInfo.zone }}
                {{ orderInfo.city && orderInfo.city }}
                {{ orderInfo.area && orderInfo.area }}
                {{ orderInfo.town && orderInfo.town }}
                {{ orderInfo.shipping_address }}
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <!-- <el-col :span="8">配送时间：</el-col> -->
              <el-col :span="12"
                >送货方式：{{ orderInfo.shipping_method }}</el-col
              >
            </el-row>
          </div>
          <table
            class="orderlist-title-wrapper"
            cellspacing="0"
            style="background-color: #fbfbfb;"
          >
            <thead>
              <tr>
                <th class="orderlist-title-name">订单商品</th>
                <th class="orderlist-title-money">数量</th>
                <th class="orderlist-title-status">单价</th>
                <th class="orderlist-title-opt">小计</th>
              </tr>
            </thead>
          </table>
          <table
            class="orderlist-title-wrapper"
            cellspacing="0"
            v-for="buck in orderInfo.products_bucket"
            :key="buck.code"
            style="padding-bottom: 44px;"
          >
            <thead>
              <div class="name">{{ buck.name }}</div>
            </thead>
            <div v-if="buck.code === 'jd' && buck.items && buck.items">
              <div
                class="product-package"
                v-for="(product_package, i) in buck.items"
                :key="product_package.child_id"
              >
                <div
                  class="package-header fx-row-between"
                  :class="i > 0 ? 'no-first' : ''"
                >
                  <div>包裹{{ $util.toChinesNum(i + 1) }}</div>
                  <div style="color: #ff482c;">
                    <span>{{ product_package.order_state_msg }}</span>
                    <el-popover
                      v-if="
                        !product_package.refund_status &&
                          product_package.cancel_tip
                      "
                      placement="bottom"
                      width="200"
                      trigger="hover"
                      content="订单取消申请中，审核需要5～30分钟，成功后，系统将自动退款，请您耐心等待。"
                    >
                      <i
                        class="el-icon el-icon-hint"
                        slot="reference"
                        click
                      ></i>
                    </el-popover>
                    <span
                      class="order-cancel"
                      @click="cancelJdOrder(product_package.child_id)"
                      v-if="product_package.is_cancel"
                    >
                      取消订单
                    </span>
                  </div>
                </div>
                <order-detail-product
                  :orderInfo="orderInfo"
                  v-for="(product, index) in product_package.items.calendar
                    .items"
                  :key="product.product_id"
                  :msg_show="
                    index === product_package.items.calendar.items.length - 1
                  "
                  :msg="product_package.items.calendar.msg"
                  :product="product"
                  :code="buck.code"
                />
                <order-detail-product
                  :orderInfo="orderInfo"
                  v-for="(product, index) in product_package.items.la_calendar
                    .items"
                  :key="product.product_id"
                  :product="product"
                  :msg_show="
                    index === product_package.items.la_calendar.items.length - 1
                  "
                  :msg="product_package.items.calendar.msg"
                  :code="buck.code"
                />
                <order-detail-product
                  :orderInfo="orderInfo"
                  v-for="(product, index) in product_package.items.default"
                  :key="product.product_id"
                  :product="product"
                  :msg_show="index === product_package.items.default.length - 1"
                />
              </div>
            </div>
            <div v-else>
              <order-detail-product
                :orderInfo="orderInfo"
                v-for="(product, index) in buck.items"
                :key="product.product_id"
                :product="product"
                :msg_show="index === buck.items.length - 1"
                :code="buck.code"
              />
            </div>
          </table>
          <div class="footer-info">
            <div v-for="item in orderInfo.totals" :key="item.id">
              <span>
                <span> {{ item.title }}： </span>
                <span
                  v-if="
                    (Number(orderInfo.shipping_refunded_credit) ||
                      Number(orderInfo.shipping_refunded_user_paid)) &&
                      item.title == '运费'
                  "
                  style="color: #ff482c"
                >
                  <span>(</span>
                  <span v-if="Number(orderInfo.shipping_refunded_credit)">
                    退余额
                    {{ orderInfo.shipping_refunded_credit | jifen }}
                  </span>
                  <span v-if="Number(orderInfo.shipping_refunded_user_paid)">
                    退自费
                    {{ orderInfo.shipping_refunded_user_paid | jifen }}
                  </span>
                  <span>)</span>
                </span>
              </span>
              <span
                :class="{
                  red_word: (item.code === 'total') | (item.code === 'coupon')
                }"
              >
                <span v-if="item.code === 'coupon'">-</span>
                {{ item.value | jifen }}
              </span>
            </div>
          </div>
          <div class="but_wrap" v-if="orderInfo.status_id == 1">
            <el-button @click="doPayNow">去支付</el-button>
          </div>
          <div class="customer_service">
            <div
              @click="showMask = true"
              v-show="
                lottery_url &&
                  (orderInfo.status_id === 2 ||
                    orderInfo.status_id === 3 ||
                    orderInfo.status_id === 17 ||
                    orderInfo.status_id === 18)
              "
              class="lottery-btn"
            >
              抽奖
            </div>

            <div
              @click="goEvaluate"
              v-if="orderInfo.order_evaluate_status !== 0"
            >
              <i class="el-icon-tickets"></i>
              {{
                orderInfo.order_evaluate_status === 1 ? "订单评价" : "查看评价"
              }}
            </div>
            <div @click="gotoCustomer">
              <i class="el-icon-service"></i>联系客服
            </div>
          </div>
        </div>
      </div>
    </div>
    <bottom-content></bottom-content>
    <el-dialog titile="提示" :visible.sync="dialogVisible" width="30%">
      <span
        >该商品您已申请过售后,如需再次申请,请点击页面下方"联系客服"或拨打客服电话
        400-088-8635 进行申请售后。</span
      >
      <span slot="footer">
        <el-button @click="dialogVisible = false">确定</el-button>
      </span>
    </el-dialog>
    <div class="mask_wrap" v-show="showMask">
      <el-row class="lottery">
        <i class="el-icon-close" @click="showMask = false"></i>
        <div class="title">恭喜您获得抽奖资格</div>
        <div class="message">海量精选奖品，等待抽取~</div>
        <div class="img">
          <img src="../../assets/images/lottery.png" alt="" />
          <canvas
            ref="myCanvas"
            style="
              position: absolute;
              top: 120px;
              left: 0;
              right:0;margin:auto;"
          ></canvas>
        </div>
        <div class="info">微信扫描参与抽奖</div>
      </el-row>
    </div>
  </div>
</template>
<script>
import QrCode from "qrcode";
import TopHeaderInfo from "@/components/top-header-info";
import TopLogo from "@/components/top-logo";
import RightNav from "@/components/right-nav";
import BottomContent from "@/components/bottom-content";
import HomeNav from "@/components/home-nav";
import LeftUserinfo from "@/components/left-userinfo";
import GOODSDEFAULT from "@/assets/images/goods_default.jpg";
import payCountdown from "@/components/pay-countdown/index.vue";
import Clipboard from "clipboard";
import orderDetailProduct from "./components/order-detail-product.vue";
export default {
  components: {
    TopHeaderInfo,
    TopLogo,
    RightNav,
    BottomContent,
    HomeNav,
    LeftUserinfo,
    payCountdown,
    orderDetailProduct
  },
  data() {
    return {
      dialogVisible: false,
      orderInfo: { order_evaluate_status: 0 },
      delivery: [],
      reverse: true,
      goodsDefault: GOODSDEFAULT,
      endTime: "",
      calendarLastId: "", //最后一个有送货时间的小件的送货id
      lacalendarLastId: "", //最后一个有送货时间的小件的送货id
      defaultId: "", //最后一个默认快递的送货id
      showMask: false,
      lottery_url: ""
    };
  },
  mounted() {
    this.getData();
  },
  computed: {
    phone_format() {
      if (this.orderInfo.shipping_phone) {
        return (
          this.orderInfo.shipping_phone.substring(0, 3) +
          "****" +
          this.orderInfo.shipping_phone.substring(7, 11)
        );
      }
      return "";
    }
  },
  methods: {
    getData() {
      this.$reqGet("api/ecomm/order/" + this.$route.params.order_id).then(
        res => {
          this.orderInfo = res.data.data;
          if (this.orderInfo.iso_end_time) {
            this.endTime = new Date(this.orderInfo.iso_end_time);
          }
          // this.orderInfo.products = [];
          // if (
          //   this.orderInfo.new_products.calendar.products &&
          //   this.orderInfo.new_products.calendar.products.length > 0
          // ) {
          //   this.orderInfo.products.push(
          //     ...this.orderInfo.new_products.calendar.products
          //   );
          //   this.calendarLastId = this.orderInfo.new_products.calendar.products[
          //     this.orderInfo.new_products.calendar.products.length - 1
          //   ].id;
          // }

          // if (
          //   this.orderInfo.new_products.la_calendar.products &&
          //   this.orderInfo.new_products.la_calendar.products.length > 0
          // ) {
          //   this.orderInfo.products.push(
          //     ...this.orderInfo.new_products.la_calendar.products
          //   );
          //   this.lacalendarLastId = this.orderInfo.new_products.la_calendar.products[
          //     this.orderInfo.new_products.la_calendar.products.length - 1
          //   ].id;
          // }
          // if (
          //   this.orderInfo.new_products.default &&
          //   this.orderInfo.new_products.default.length > 0
          // ) {
          //   this.orderInfo.products.push(
          //     ...this.orderInfo.new_products.default
          //   );
          //   this.defaultId = this.orderInfo.new_products.default[
          //     this.orderInfo.new_products.default.length - 1
          //   ].id;
          // }
          if (this.orderInfo.status_id !== 1) {
            this.getLottery();
          }
          this.orderInfo.products_bucket = this.orderInfo.products_bucket.filter(
            item => {
              if (item.code === "jd") {
                item.items.filter(parcel => {
                  return parcel.items.length > 0;
                });
              }
              return item.items.length > 0;
            }
          );
          // this.initItem();
        }
      );
    },
    initItem() {
      let products = [];
      let groups = {};
      this.orderInfo.products.map(group => {
        if (group.group_product_id) {
          if (groups[group.group_product_id]) {
            groups[group.group_product_id].push(group);
          } else {
            groups[group.group_product_id] = [];
            groups[group.group_product_id].push(group);
          }
        } else {
          products.push(group);
        }
      });
      for (let key in groups) {
        let obj = {
          group_product_id: key,
          groups: groups[key]
        };
        products.push(obj);
      }
      this.orderInfo.products = products;
    },

    doPayNow() {
      if (this.orderInfo.products[0].supplier === "quyundong") {
        this.$router.push({
          name: "qyd-submit-order",
          params: { order_id: this.orderInfo.id }
        });
        return;
      }
      this.$router.push({
        name: "submit-order",
        params: { order_id: this.orderInfo.id }
      });
    },
    gotoCustomer() {
      this.$reqGet("/api/store/udesk/orderPage/" + this.orderInfo.id).then(
        res => {
          if (res.data.success) {
            window.open(res.data.data.url);
          }
        }
      );
    },
    getLottery() {
      this.$reqGet("/api/customization/eqxiu/login", {
        order_id: this.$route.params.order_id
      }).then(res => {
        if (res.data.success) {
          this.lottery_url = res.data.data.url;
          if (this.lottery_url) {
            this.$nextTick(() => {
              QrCode.toCanvas(this.$refs.myCanvas, res.data.data.url, {
                width: 160,
                height: 160
              });
            });
          }
        }
      });
    },
    copyOrderId() {
      var clipboard = new Clipboard(".copy-btn");
      clipboard.on("success", () => {
        clipboard.destroy();
      });
      this.$message({
        type: "success",
        message: "复制成功!"
      });
    },
    cancelJdOrder(jd_order_id) {
      this.$confirm("您确认取消当前子订单吗？", {
        confirmButtonText: "确认取消",
        cancelButtonText: "我再想想",
        type: "warning"
      }).then(() => {
        this.$reqPost(
          "api/ecomm/order/cancel-jd-order/" + this.$route.params.order_id,
          {
            jd_order_id: jd_order_id
          },
          {
            noAlertMessage: true, //不展示请求失败后的警告弹窗
            noStringify: true
          }
        ).then(res => {
          if (res.data.success) {
            this.$message({
              type: "success",
              message: "取消订单申请提交成功！"
            });
            this.getData();
          }
        });
      });
    },
    goEvaluate() {
      this.$router.push({
        name: "evaluate",
        query: { order_id: this.$route.params.order_id }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.site-nav {
  padding: 20px 0;
  color: #999;
  font-size: 16px;
  a {
    color: #999;
  }
  a:first-child {
    color: #444;
  }
}
.right-detail-wrap {
  position: relative;
  margin-bottom: 40px;
  min-height: 572px;
  width: 980px;
  left: 220px;
  box-sizing: border-box;
  padding: 22px 25px 60px;
  background-color: #fff;
  .top-info {
    .el-col {
      line-height: 36px;
      border-bottom: 1px solid #f0f0f0;
      margin: 0 10px;
      box-sizing: border-box;
    }
  }
  .customer_service {
    border-top: 1px solid #f0f0f0;
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;
    padding-top: 10px;
    &::after {
      content: " ";
      display: block;
      clear: both;
    }
    > div {
      font-size: 12px;
      border: 1px solid #f0f0f0;
      padding: 5px 10px;
      background: #fcfbfe;
      border-radius: 3px;
      text-align: center;
      color: #000;
      cursor: pointer;
      margin-left: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      > i {
        padding-right: 5px;
        font-size: 15px;
      }
    }
    .lottery-btn {
      background: #fb6929;
      color: #fff;
    }
  }
  .orderlist-title-wrapper {
    text-align: center;
    box-sizing: border-box;
    // background-color: #fbfbfb;
    border: 1px solid #f5f5f5;
    margin: 20px 0;
    .name {
      height: 40px;
      background: #fbfbfb;
      font-size: 14px;
      font-weight: 500;
      color: #222222;
      line-height: 40px;
      text-indent: 12px;
      text-align: left;
    }
    .product-package {
      background-color: #fff;
      .package-header {
        padding: 0 40px;
        height: 52px;
        font-size: 14px;
        color: #666666;
        position: relative;
        &.no-first {
          margin-top: 32px;
        }
        &:after {
          content: "";
          display: inline-block;
          width: 850px;
          height: 1px;
          background-color: #eeeeee;
          position: absolute;
          left: 40px;
          bottom: 0;
        }
        .order-cancel {
          display: inline-block;
          width: 72px;
          height: 24px;
          border-radius: 13px;
          border: 1px solid #fc0010;
          font-size: 14px;
          color: #fc0010;
          line-height: 24px;
          margin-left: 12px;
          cursor: pointer;
        }
      }
    }
    th {
      // width: 162px;
      width: 130px;
      height: 40px;
      line-height: 40px;
      color: #222222;
    }
    .orderlist-title-name {
      width: 460px;
      padding-left: 40px;
    }
    .orderlist-title-opt {
      padding-right: 40px;
    }
  }

  .footer-info {
    margin-top: 30px;
    text-align: right;
    line-height: 36px;
    & > div > span {
      display: inline-block;
      min-width: 120px;
    }
  }
}
.red_word {
  color: #fc0010;
}
.big_word {
  font-size: 20px;
  color: #e2333f;
}
.red-color {
  color: #db3d3c;
}
.but_wrap {
  padding-top: 30px;
  text-align: right;
  background-color: #fff;
  .el-button {
    width: 198px;
    height: 46px;
    background: rgba(226, 51, 63, 1);
    border-radius: 5px;
    font-size: 16px;
    color: #fff;
    border: none;
  }
}
.copy-btn {
  color: #666666;
  font-size: 12px;
  margin-left: 5px;
  background-color: #eeeeee;
  border-radius: 4px;
  padding: 2px 8px;
  cursor: pointer;
}
.mask_wrap {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2000;
  background: rgba(1, 1, 1, 0.6);
  .lottery {
    width: 800px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background-color: #fff9ec;
    border: 1px solid #f0d985;
    text-align: center;
    padding: 10px;
    color: #333;
    > i {
      position: absolute;
      right: 10px;
      top: 10px;
      cursor: pointer;
    }
    .title {
      font-size: 20px;
      margin-bottom: 10px;
    }
    .message {
      font-size: 18px;
      color: #e2343f;
    }
    > .img {
      width: 426px;
      height: 300px;
      margin: 0 auto;
      position: relative;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .info {
      font-size: 12px;
      padding-top: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/order-detail.vue